import { useCallback } from 'react';
import { Button } from '@mui/material';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { ArrowForward } from '@mui/icons-material';

import { Input } from '../../../components/Input';
import { CpfInput } from '../../../components/CpfInput';

import { SectionInputs, Subtitle } from './styles';
import {
  Company,
  signUpRequest,
  updateAccountRequest,
} from '../../../services';

import useAuthStore from '../../../store/auth';

import {
  isValidCPF,
  removeDotsAndTracesCPF,
} from '../../../utils/cpfValidation';

interface FormCriarUsuarioProps {
  handleNext: any;
  handleReset: any;
  companyId: string;
  accountId: string;
  company?: Company;
  setIsLoading: (status: boolean) => void;
  setIsLoadingText: (text: string) => void;
}

export const FormCriarUsuario = ({
  handleNext,
  handleReset,
  companyId,
  accountId,
  company,
  setIsLoading,
  setIsLoadingText,
}: FormCriarUsuarioProps) => {
  const user = useAuthStore(state => state.user);

  const formValidation = useCallback((): any => {
    return Yup.object().shape({
      email: Yup.string()
        .email('Digite um e-mail válido')
        .required('É necessário adicionar um e-mail.'),
      name: Yup.string()
        .min(4, 'Mínimo de 4 Dígitos')
        .required('É necessário adicionar um Nome.'),
      cpf: Yup.string()
        .required('O campo CPF é obrigatório.')
        .min(11, 'Mínimo de 11 dígitos')
        .test('test-invalid-cpf', 'CPF inválido', cpf =>
          isValidCPF(cpf as string),
        ),
    });
  }, []);

  const { control, handleSubmit } = useForm({
    resolver: yupResolver(formValidation()),
    reValidateMode: 'onBlur',
  });

  const handleCreateAccount = useCallback(
    async (formData: any) => {
      setIsLoadingText('Carregando Informações do Usuário');
      setIsLoading(true);
      try {
        const response = await signUpRequest({
          name: formData?.name,
          email: formData?.email,
          profile: 'UN2',
          companies_ids: [companyId],
          companies: [{ ...company! }],
          doc: removeDotsAndTracesCPF(formData?.cpf),
          userId: user?.id as string,
        });

        if (response?.status === 201) {
          const usuario = response?.data;

          const accountUpdated = {
            admins: [
              {
                id: usuario.id,
                name: usuario.name,
                email: usuario.email,
                avatar_url: usuario.avatar_url,
                profile: usuario.profile,
                status: usuario.status,
                phone: usuario.phone,
                doc: usuario.doc,
              },
            ],
            admins_ids: [usuario.id],
          };

          const responseAccount = await updateAccountRequest(
            accountUpdated,
            accountId,
            user?.id as string,
          );

          if (responseAccount?.status === 200) {
            // console.log({
            //   formData,
            //   usuario,
            //   responseAccount,
            //   companyId,
            //   accountId,
            // });
            handleNext();
            handleReset();
          }
        }
      } catch (error) {
        console.log('Error handleCreateAccount', error);
      } finally {
        setIsLoading(false);
      }
    },
    [
      companyId,
      company,
      user?.id,
      accountId,
      handleNext,
      handleReset,
      setIsLoading,
      setIsLoadingText,
    ],
  );

  return (
    <form onSubmit={handleSubmit(handleCreateAccount)}>
      <SectionInputs>
        <Subtitle>
          Esse será o usuário admin, ele poderá criar e editar empresas dentro
          desta conta.
        </Subtitle>
        <Input
          name="email"
          control={control}
          fullWidth
          label="E-mail do usuário"
        />
        <Input
          name="name"
          control={control}
          fullWidth
          label="Nome do usuário"
        />
        <Input
          fullWidth
          id="outlined-basic"
          label="CPF"
          name="cpf"
          control={control}
          InputProps={{ inputComponent: CpfInput as any }}
        />
      </SectionInputs>
      <Button
        endIcon={<ArrowForward />}
        type="submit"
        variant="contained"
        color="success"
        className="btn-save"
        sx={{ color: '#fff' }}
      >
        Continuar
      </Button>
    </form>
  );
};
